import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { useCustomerQueries } from '@dashboard/hooks/queries/useCustomerQueries';
import { format } from 'date-fns';
import StatisticsList from './StatisticsList';
import Spinner from '@dashboard/components/Spinner/Spinner';

function useRecentCustomers() {
  const { sellerId } = useAuth();

  const { getCustomers } = useCustomerQueries();

  const { data, isError, isLoading } = useQuery({
    queryKey: ['recentCustomers', sellerId],
    queryFn: () =>
      getCustomers({
        limit: 4,
      }),
    staleTime: 1000 * 60, // 5 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  return {
    isLoading,
    isError,
    data,
  };
}

export default function RecentCustomers() {
  const { data, isLoading, isError } = useRecentCustomers();

  return (
    <StatisticsList.List>
      {isLoading && (
        <>
          <Spinner />
        </>
      )}

      {isError && <StatisticsList.EmptyState>Something went wrong</StatisticsList.EmptyState>}

      {!data?.length && <StatisticsList.EmptyState>No customers yet</StatisticsList.EmptyState>}

      {data?.map(customer => (
        <StatisticsList.Item key={customer._id} href={`/customers/${customer._id}`}>
          <StatisticsList.Left>
            {customer.name ? (
              <>
                <StatisticsList.PrimaryText>{customer.email}</StatisticsList.PrimaryText>
                <StatisticsList.SecondaryText>{customer.name}</StatisticsList.SecondaryText>
              </>
            ) : (
              <>
                <StatisticsList.PrimaryText>{customer.email}</StatisticsList.PrimaryText>
                <>&nbsp;</>
              </>
            )}
          </StatisticsList.Left>

          <StatisticsList.Right>
            <StatisticsList.SecondaryText>
              {format(new Date(customer.createdAt), 'MMM d, yyyy HH:mm')}
            </StatisticsList.SecondaryText>

            <>&nbsp;</>
          </StatisticsList.Right>
        </StatisticsList.Item>
      ))}
    </StatisticsList.List>
  );
}
